// @flow
import InformsStandartSms from './InformsStandartSms';

export default InformsStandartSms;
